import { createFileRoute, Outlet } from "@tanstack/solid-router";
import { loadTemplate } from "../../backend/data-loaders/loadTemplate";

export const Route = createFileRoute("/templates/$templateId")({
  loader: async ({ params: { templateId } }) =>
    await loadTemplate(templateId, "/"),
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
